<template>
  <div class="cargo-list-wrapper">
    <div class="cargo-list">
      <div class="cargo-item h-outer-border around-4 bw3 bz0 h-bg brown-2"
           :class="['quality-' + item.quality]"
           v-for="item in list">
        <HArtifact :artifact="item"></HArtifact>
        <div class="cargo-info title">
          <p class="name">
            {{ item.nameCn }}
          </p>
          <p class="stock">
            x {{ item.amount }}
          </p>
        </div>
        <div class="buttons">
          <div class="btn-trade" @click="handleSell(item)">寄卖
          </div>
        </div>
      </div>
    </div>

    <HPager :page="pager.page" :pageSize="pager.pageSize" :total="pager.total" @pageChange="handlePageChange"></HPager>

    <SellPopup v-if="sellShow"
               :sellItemInfo="sellItemInfo"
               @close="sellShow=false"
               @refresh="handleRefresh">
    </SellPopup>
  </div>
</template>

<script>
  import SellPopup from './sell-popup'
  import HArtifactInfoBox from '@/components/h-artifact-info-box/index'
  import HArtifact from '@/components/h-artifact/index'
  import { mapActions, mapGetters } from 'vuex'
  import API from '@js/api'
  import HPager from '@/components/base/h-pager/index'

  export default {
    data () {
      return {
        sellItemInfo: null,
        buyLoading: false,
        sellShow: false,
        list: [],
        pager: {
          page: 0,
          pageSize: 9,
          total: 0,
        },
      }
    },

    computed: {
      ...mapGetters('hero', [
        'gold',
        'backpackItems',
      ]),
    },

    mounted () {
      this.getSaleableList()
    },

    methods: {
      ...mapActions('hero', [
        'getGold',
      ]),

      async getSaleableList () {
        try {
          const { list, count } = await API.market.getSaleableList({
            page: this.pager.page,
            pageSize: this.pager.pageSize,
          })
          this.list = list
          this.pager.total = count
        } catch (err) {
          console.error(err)
        }
      },

      async handleSell (item) {
        try {
          this.sellItemInfo = JSON.parse(JSON.stringify(item))
          this.sellShow = true
        } catch (err) {
          this.$message(err)
        } finally {
          this.buyLoading = false
        }
      },

      handlePageChange (page) {
        this.pager.page = page
        this.getSaleableList()
      },

      handleRefresh () {
        this.getGold()
        this.getSaleableList()
      },
    },

    components: {
      HArtifactInfoBox,
      SellPopup,
      HArtifact,
      HPager,
    }
  }
</script>

<style lang="stylus" scoped>
  .cargo-list-wrapper
    position relative
    height 100%

  .cargo-list
    display flex
    flex-wrap wrap
    align-content flex-start
    height calc(245px + 28px)

  .cargo-item
    position relative
    width calc(33.33% - 4px)
    height 65px
    display flex
    align-items center
    margin 0 2px 4px 2px
    padding 5px
    user-select none
    &:hover
      z-index 2
      box-shadow 1px 1px 0 1px #000
    > div
      flex-shrink 0
    .icon
      width 55px
      height 55px
      display flex
      align-items center
      justify-content center
      padding 3px
      z-index 2
      &:hover .h-artifact-info-box
        display block
      .icon-wrapper
        position relative
      .artifact-icon
        max-width 100%
        max-height 100%
        vertical-align top
    .cargo-info
      display flex
      flex-direction column
      justify-content space-evenly
      padding 0 5px
      flex-grow 1
      height 100%
      &:after
        width 130px
      .name
        line-height 16px
        font-size 12px
        letter-spacing 1px
        whiteText1()
      .sell-gold
        font-size 12px
        goldText1()
      .stock
        line-height 14px
        font-size 12px
        whiteText1()
        opacity 0.6

    .buttons
      display flex
      flex-direction column
      align-items center
      justify-content center
      .btn-trade
        z-index 1
        padding 3px 10px
        border 1px solid #78624a
        border-radius 2px
        text-align center
        font-size 12px
        background-color #392519
        cursor pointer
        user-select none
        letter-spacing 1px
        goldText1()
        &:hover
          color darken($colorGold, 30%)
          cursor pointer
        &.disabled
          color rgba(255, 255, 255, .2)
          border-color rgba(255, 255, 255, .2)
          cursor not-allowed
</style>
